import Home from './Container';

export default Home;
